<template>
    <v-dialog
        v-model="isOpen"
        persistent
        max-width="500"
    >
        <v-card>
            <v-card-title class="headline">
                {{$t('email_confirmation')}}
            </v-card-title>
            <v-card-text>
                <span v-html="$t('we_sent_mail_to_your_email_confirm', {email: user.email})"></span>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="close()">
                    {{$t('close')}}
                </v-btn>
                <v-btn color="primary" text @click="toEmail()">
                    {{$t('to_email')}}
                </v-btn>
            </v-card-actions>
            <overlay-loader :show="isLoading"></overlay-loader>
        </v-card>
    </v-dialog>
</template>

<script>
    import OverlayLoader from '@/app/shared/components/app-loader/Loader';

    export default {
        name: 'VerificateEmailModal',
        components: {
            OverlayLoader,
        },
        props: [
            'user',
        ],
        data() {
            return {};
        },
        created() {
        },
        computed: {
            isLoading() {
                return this.$store.getters.AUTH_IS_LOADING;
            },
            isOpen() {
                return this.$store.getters.IS_EMAIL_VALIDATION_OPENED;
            },
        },
        methods: {
            toEmail() {
                this.$store.dispatch('EMAIL_VALIDATION', false);
                window.open(`//${this.user.email}`, '_blank');
            },
            close() {
                this.$store.dispatch('EMAIL_VALIDATION', false);
            }
        },
    };
</script>
